import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {useProcessingRequest} from "../../../store/selectors/tableManagementSelector";
import {useServerSidePagination} from "../../../hooks/PaginationHooks";
import {fullPayoutApi} from "../../../api/fullPayoutApi";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import {
    BasicTableRowStyles,
    MainContentWrapper,
    TableHeaderWrapper,
    TableWrapper
} from "../../../components/common/Common.styles";
import dayjs from "dayjs";
import DownloadBtn from "../../../components/common/table/DownloadBtn";
import {ServerSidePagination} from "../../../components/common/table/ServerSidePagination";
import {CircularIndeterminate} from "../../../components/common/CircularIndeterminate";
import CellBox from "../../../components/common/table/CellBox";
import BorderRow from "../../../components/common/table/BorderRow";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
export default function FullPayoutPayoutsPage() {
    const { t } = useTranslation();
    const { shopModuleId } = useParams<{ shopModuleId: string }>();
    const moduleId = Number(shopModuleId);

    const processingRequest = useProcessingRequest();

    const paginatedData = useServerSidePagination(
        async (paginationParameters) => {
            const res = await fullPayoutApi.getPayouts(paginationParameters, moduleId);
            return res?.getResultOrNull();
        },
        [moduleId],
        "desc",
        "payoutTimestamp"
    );

    return (
        <>
            <PageTitle
                breadcrumbs={[
                    {
                        title: "fullPayoutPage.title",
                        link: "analysisfiles/fullpayout",
                    },
                ]}
                title={t("fullPayoutPage.payoutsTitle")}
            />

            <MainContentWrapper>
                <TableWrapper minWidth="800px" columnsTemplate="1fr 1fr 150px">
                    <TableHeaderWrapper>
                        <ServerSideTableColumnHeader
                            isSorted={false}
                            label={t("fullPayoutPage.column.date")}
                            firstCol
                            paginatedData={paginatedData}
                        />
                        <ServerSideTableColumnHeader
                            isSorted={false}
                            label={t("fullPayoutPage.column.totalPoints")}
                            paginatedData={paginatedData}
                        />
                        <ServerSideTableColumnHeader
                            isSorted={false}
                            label={t("fullPayoutPage.column.download")}
                            paginatedData={paginatedData}
                            lastCol
                        />
                        <BorderRow />
                    </TableHeaderWrapper>

                    <Box sx={{ display: "contents" }}>
                        {paginatedData.items.map((item) => (
                            <BasicTableRowStyles key={item.id}>
                                <CellBox firstCol>
                                    <Typography>
                                        {dayjs(item.payoutDate).format("DD.MM.YYYY")}
                                    </Typography>
                                </CellBox>
                                <CellBox>
                                    <Typography>{item.totalPoints}</Typography>
                                </CellBox>
                                <CellBox lastCol contentPosition="center">
                                    {item.pdfDownloadUrl
                                        ? <DownloadBtn downloadUrl={item.pdfDownloadUrl} />
                                        : <Typography variant="caption" color="textSecondary">
                                            {t("fullPayoutPage.noPdf")}
                                        </Typography>}
                                </CellBox>
                                <BorderRow />
                            </BasicTableRowStyles>
                        ))}
                    </Box>
                </TableWrapper>

                <ServerSidePagination paginatedData={paginatedData} />
            </MainContentWrapper>

            <CircularIndeterminate processingRequest={processingRequest} />
        </>
    );
}